import { requestSubscription, graphql } from "react-relay";
import { ConnectionHandler } from "relay-runtime";
import environment from "../Network";

const subscription = graphql`
  subscription MessageSubscription {
    messageSubscription {
      action
      users
      messageId
      message {
        sender {
          displayName
        }
        body
        createdAt
        expireDate
        sentToAll
        receivers {
          edges {
            node {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;

export default (variables) => {
  return requestSubscription(
    environment, // see Environment docs
    {
      subscription,
      variables: variables ? variables : {},
      updater: (store) => {
        // Get the notification
        const rootField = store.getRootField("messageSubscription");
        if (rootField) {
          const message = rootField.getLinkedRecord("message");
          const message_id = message
            ? message.getValue("id")
            : rootField.getValue("messageId");
          const action = rootField.getValue("action");
          const users = rootField.getValue("users");
          const sentToAll = message ? message.getValue("sentToAll") : true;
          let viewer = store.getRoot().getLinkedRecord("user");
          let pk = viewer.getValue("pk");
          if (sentToAll || users.indexOf(pk) !== -1) {
            let connection_lastMessages = ConnectionHandler.getConnection(
              viewer,
              "EventList_lastMessages"
            );
            if (action === "remove") {
              if (connection_lastMessages)
                ConnectionHandler.deleteNode(
                  connection_lastMessages,
                  message_id
                );
            } else {
              let notificationEdge = ConnectionHandler.createEdge(
                store,
                connection_lastMessages,
                message,
                "MessageType"
              );
              ConnectionHandler.insertEdgeBefore(
                connection_lastMessages,
                notificationEdge
              );
            }
          }
          viewer = store.getRoot().getLinkedRecord("adminDashboard");
          if (viewer) {
            let connection = null;
            if (action === "remove") {
              connection = ConnectionHandler.getConnection(
                viewer,
                "PrivateNewsTab_privateNews"
              );
              ConnectionHandler.deleteNode(connection, message_id);
              connection = ConnectionHandler.getConnection(
                viewer,
                "TeamNewsTab_teamNews"
              );
              ConnectionHandler.deleteNode(connection, message_id);
            } else {
              if (sentToAll) {
                connection = ConnectionHandler.getConnection(
                  viewer,
                  "TeamNewsTab_teamNews"
                );
              } else {
                connection = ConnectionHandler.getConnection(
                  viewer,
                  "PrivateNewsTab_privateNews"
                );
              }
              const notificationEdge = ConnectionHandler.createEdge(
                store,
                connection,
                message,
                "MessageType"
              );
              ConnectionHandler.insertEdgeBefore(connection, notificationEdge);
            }
          }
        }
      },
      // optional but recommended:
      onCompleted: () => {
        /* server closed the subscription */
      },
      onError: (error) => console.error(error),
    }
  );
};



// WEBPACK FOOTER //
// ./src/subscriptions/MessageSubscription.js